<!--
Author: TangChen
Date: 2018-11-21
Desc: 基金超市
 -->
<template>
    <div :class="'bizcomp-trade-record bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/fund' }">
                    基金交易
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <div class="trade-record">
            <el-table
                :data="fund"
                style="width: 100%"
                class="tab-list-tit"
            >
                <el-table-column
                    prop="fundname"
                    label="基金名称"
                    align="center"
                    :formatter="formatterName"
                    width="180"
                />
                <el-table-column
                    prop="serialno"
                    label="协议单号"
                    align="center"
                    width="180"
                />
                <el-table-column
                    label="申请时间"
                    align="center"
                    width="120"
                >
                    <template slot-scope="scope">
                        <div>{{ formatterDate('','',scope.row.systemdate) }}</div>
                        <div>{{ scope.row.systemtime }}</div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="applicationvol"
                    label="预约份额"
                    align="center"
                    width="120"
                    :formatter="formatterApplicationVol"
                />
                <el-table-column
                    prop="investvalue"
                    label="赎回开放日"
                    align="center"
                    width="120"
                    :formatter="formatterDate"
                />
                <el-table-column
                    prop="transactionaccountid"
                    label="交易账户"
                    align="center"
                    width="120"
                    :formatter="formatterTraId"
                />
                <el-table-column
                    prop="businesscode"
                    label="业务名称"
                    align="center"
                    width="120"
                    :formatter="formatterBusinesscode"
                />
                <el-table-column
                    prop="status"
                    label="处理状态"
                    align="center"
                    width="120"
                    :formatter="formatterStatus"
                />
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <div
                            v-show="scope.row.status == '0'"
                            type="primary"
                            size="small"
                            style="cursor: pointer;color: rgb(50,183,242);font-weight: 600;"
                            v-on:click.stop="stopSell(scope.row.serialno)"
                        >
                            终止预约
                        </div>
                        <div
                            v-show="scope.row.status == '7' || scope.row.status == '2'"
                            type="primary"
                            size="small"
                            style="cursor: pointer;color: rgb(50,183,242);font-weight: 600;"
                            v-on:click.stop="failMsg(scope.row.errmsg)"
                        >
                            作废原因
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="allPage > pagecount" class="page-box">
                <el-pagination
                    :page-size="Number(pagecount)"
                    :current-page.sync="curPage"
                    background
                    layout="prev, pager, next"
                    :total="Number(allPage)"
                    v-on:current-change="pageRefresh"
                />
            </el-row>
        </div>
        <el-dialog title="终止预约" :visible.sync="dialogVisible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p><i class="el-icon-warning" /><span>您是否确认终止该预约协议？</span></p>
                </div>
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="37px"
                    size="small"
                >
                    <el-form-item label="" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入交易密码"
                        />
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="dialogVisible = false">
                    返回
                </el-button>
                <el-button type="primary" v-on:click="cancelConfirm">
                    确定
                </el-button>
            </div>
        </el-dialog>

        <el-dialog title="作废原因" :visible.sync="dialogErrVisible" class="prop info-tips" width="480px">
            <div class="investor-tips">
                <div class="prompt-info">
                    <p><i class="el-icon-warning" /><span>{{ errmsg }}</span></p>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="dialogErrVisible = false">
                    确定
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";

export default {
    name: "PreSellList",
    mixins: [mixin],
    data () {
        return {
            curPage: 1,
            searchText: "",
            fund: [],
            pagecount: "",
            pageoffset: "0",
            allPage: "0",
            queryFind: null,
            fundFrom: "1",
            query: null,
            index: 0,
            dialogVisible: false,
            dialogErrVisible: false,
            // 预约终止密码校验
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    { required: true, message: "请输入交易密码", trigger: "blur" }
                ]
            },
            serialno: "",
            errmsg: ""
        };
    },
    computed: {
        systemDate(val){
            return this.formatterDate(val);
        }
    },
    watch: {
        fundFrom (val,old) {
            this.pageoffset = "0";
            this.doAction();
        }
    },
    created () {
        this.fundFrom = this.$cache.getParams().is_zx == "1" ? "1" : "2";
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
    },
    methods: {
        formatterDate (row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterName (row, column, value) {
            if (row.businesscode === "D2" || row.businesscode === "69" || (row.businesscode === "24" && (row.businesskind === "2" || row.businesskind === "6"))) {
                return row.targetfundname + "(" + (row.targetfundcode === "515981" ? "515980" : row.targetfundcode) + ")";
            }
            return row.fundname + "(" + row.fundcode + ")";
        },
        formatterApplicationVol(row, column, value) {
            return value + "(份)";
        },
        formatterBusinesscode(row, column, value){
            return this.$cache.getDict("130010",value);
        },
        formatterTraId(row,column,value){
            return this.$cache.getDict("110080",row.channelid) + "(尾号" + row.depositacct.substr(-4,4) + ")";
        },
        formatterStatus(row, column, statusCn) {
            let statusStr = "";
            if(statusCn == "0"){
                statusStr = "申请有效";
            }else if(statusCn == "1"){
                statusStr = "已生成";
            }else if(statusCn == "3"){
                statusStr = "已终止预约";
            }else if(statusCn == "2" || statusCn == "7"){
                statusStr = "系统作废";
            }
            return statusStr;
        },
        // 预约终止操作确认
        cancelConfirm () {
            const _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    const _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    this.$util.request("booking/sell/stop", { serialno: this.serialno, tradepwd: _pwd }, "POST").then(res => {
                        if (res.data) {
                            _this.ruleForm.tradepwd = "";
                            _this.dialogVisible = false;
                            _this.doAction();
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        // 弹出预约终止界面
        stopSell (val) {
            this.serialno = val;
            this.dialogVisible = true;
        },
        failMsg(val){
            this.errmsg = val;
            this.dialogErrVisible = true;
        },
        pageRefresh (val) {
            this.pageoffset = val - 1;
            this.doAction();
        },

        // 获取预约记录信息
        getFund (val, cb) {
            this.$util.request("booking/sell/funds", {
                pagecount: cb ? "1000" : this.pagecount,
                pageoffset: ((val ? "0" : this.pageoffset) * this.pagecount).toString()}, "GET", false).then(res => {
                if (res.data) {
                    if (!cb) {
                        this.allPage = res.alllength;
                        this.fund = res.data;
                    } else {
                        cb.call(this, res.data);
                    }
                }
            });
        },
        //请求限制
        actionLimit(){
            const _this = this;
            if(this.query !== null){
                clearTimeout(this.query);
                this.index++;
            }
            this.query = setTimeout(()=>{
                _this.index = 0;
                clearTimeout(this.query);
            },2000);
            if(this.index > 3){
                this.$alert("您请求太频繁，请等待一会！", "访问提示");
                _this.index = 0;
                /* this.query = setTimeout(()=>{
                    _this.index = 0;
                    clearTimeout(this.query);
                },500); */
            }
            return true;
        },
        // 对预约记录频繁查询请求做处理
        doAction (val, cb) {
            this.actionLimit();
            this.fund = [];
            this.allPage = 0;
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 100);
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-trade-record {
    /*自定义时间控件*/
    .custom-time {
        display: inline-block;
        vertical-align: middle;
        .comp-date-picker {
            width: auto;
        }
        .el-button {
            min-width: 100px;
            border-color: $color-b;
            color: $color-b;
            background-color: $bg5;
            padding: 8px 15px;
            margin-left: 13px;
        }
    }
    .redemp-btn{margin-left: 3%;}
    .info-tips {
        .two-cols-form .el-form-item__content {
            .el-input {
                width: 70%;
            }
        }
        .prompt-info {
            .el-icon-warning {
                color: $color-a;
                margin-right: 8px;
                font-size: $f24;
                vertical-align: middle;
            }
            span {
                vertical-align: middle;
            }
        }
    }
    .remit-infos{
        text-align: right;
        color: blue;
        cursor: pointer;
    }
    .contract-btn {
        color: #fff;
        background-color: rgb(255, 187, 0);
    }
    .contract-download-btn {
        color: #fff;
        background-color: rgb(230, 0, 18);
    }
}
</style>
